const asphaltRoofing = [
  {
    question: "What are asphalt shingles made of?",
    answer:
      "Asphalt shingles<IN_CITY_ZIP> are composed of a fiberglass or organic base mat, coated with asphalt and topped with ceramic granules. This multilayer design provides waterproofing, UV protection, and long-term durability.",
  },
  {
    question: "How long does an asphalt shingle roof last?",
    answer:
      "With proper installation and maintenance, asphalt shingle roofs<IN_CITY_ZIP> typically last 20 to 30 years. Architectural and premium shingles may last up to 40 years depending on weather exposure and attic ventilation.",
  },
  {
    question: "Do I need a permit to install or replace a roof?",
    answer:
      "Yes. Roofing projects<IN_CITY_ZIP> require city permits and inspections. Modern Build handles all paperwork and ensures full compliance with local building codes and safety regulations.",
  },
  {
    question: "How long does it take to replace an asphalt shingle roof?",
    answer:
      "Most residential asphalt roof replacements<IN_CITY_ZIP> take 1 to 3 days, depending on the size, slope, number of layers, and any necessary repairs. We provide a detailed timeline with every estimate.",
  },
  {
    question: "Are asphalt shingles suitable for hot climates?",
    answer:
      "Yes. Modern asphalt shingles<IN_CITY_ZIP> are manufactured with heat-reflective technology and UV-resistant granules, making them ideal for hot, sunny regions like Southern California.",
  },
  {
    question: "What types of asphalt shingles do you offer?",
    answer:
      "We install three-tab, architectural, and designer asphalt shingles<IN_CITY_ZIP> from top brands. Our team helps you select the best style for your budget, performance needs, and curb appeal.",
  },
  {
    question: "Can a new asphalt roof be installed over existing shingles?",
    answer:
      "In some cases, yes. However, we usually recommend a full tear-off<IN_CITY_ZIP> to inspect the underlying deck and ensure maximum lifespan. Our roofers will evaluate your structure and advise the best option.",
  },
  {
    question: "How much does asphalt roofing cost?",
    answer:
      "Costs<IN_CITY_ZIP> depend on square footage, pitch, shingle style, and required repairs. Most asphalt roofing installations range from $7,500 to $15,000. We provide free on-site estimates.",
  },
  {
    question: "Are warranties available on asphalt shingles?",
    answer:
      "Yes. We offer both manufacturer warranties and workmanship guarantees<IN_CITY_ZIP>. Warranty terms vary by product line and install method — we’ll review all options during your consultation.",
  },
  {
    question: "How do I know if my asphalt roof needs to be replaced?",
    answer:
      "Signs your asphalt roof<IN_CITY_ZIP> may need replacement include curled or missing shingles, dark streaks, frequent leaks, or visible sagging. We offer free inspections to evaluate roof condition and lifespan.",
  },
];

export default asphaltRoofing;
